import script from "./CategoryManager.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryManager.vue?vue&type=script&setup=true&lang=js"

import "./CategoryManager.vue?vue&type=style&index=0&id=3f23e7aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f23e7aa"]])

export default __exports__